import { cloneDeep, mergeWith, toPlainObject } from 'lodash'

import { empty } from '@sigma-frontend-libs/commons'
import { CSendingTypesGenerallyAvailable } from '@sigmasms/commons'

import { isArrayNotEmpty, request } from '@/utils'

export default {
  namespaced: true,

  state: {
    account: empty.users.create,
    sendingTypes: CSendingTypesGenerallyAvailable,
    isPlatinum: false
  },

  mutations: {
    fillAccount(state, account) {
      account = toPlainObject(account)
      state.account = mergeWith({}, cloneDeep(empty.users.create), account, (a, b) => {
        if (Array.isArray(b)) {
          return b
        }

        return undefined
      })
    },

    setSendingTypes(state, types) {
      state.sendingTypes = types
    },
    setPlatinumStatus(state, status) {
      state.isPlatinum = status
    }
  },

  actions: {
    async getAccount({ commit, dispatch }, userId) {
      const data = await request.get(`users/${userId}`, undefined, { $scope: [ 'full' ] })
      if (data) {
        const types = []
        for (const type of CSendingTypesGenerallyAvailable) {
          if (
            isArrayNotEmpty(data.Tariffs) &&
            data.Tariffs.find(tariff => {
              return tariff.source === `sendings.${type}`
            }) &&
            isArrayNotEmpty(data.RoutingGroups) &&
            data.RoutingGroups.find(routingGroup => {
              return routingGroup.type === type
            })
          ) {
            types.push(type)
          }
        }

        commit('setSendingTypes', types)

        const { permissions } = await dispatch('settings/getGlobalSettings', null, { root: true })
        data.permissions = permissions

        commit('fillAccount', data)
      }
    },

    setAccount({ commit }, account) {
      commit('fillAccount', account)
    },
    setPlatinumStatus({ commit }, status) {
      commit('setPlatinumStatus', status)
    }
  },

  getters: {
    account: state => {
      return state.account
    },
    sendingTypes: state => {
      return state.sendingTypes
    },
    isPlatinum: state => {
      return state.isPlatinum
    }
  }
}
